module.exports = __webpack_public_path__ + "static/img/AI2.05ee9305.png";